module.exports = __webpack_public_path__ + "img/electron-gold.acc7c538.svg";